import { route } from 'quasar/wrappers';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import routes from './routes';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

function waitForElement(selector: string, callback: () => void) {
  const el = document.querySelector(selector);
  if (el) {
    callback();
    return;
  }

  const observer = new MutationObserver(() => {
    if (document.querySelector(selector)) {
      observer.disconnect();
      callback();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Safety timeout — disconnect after 5 seconds if element never appears
  setTimeout(() => observer.disconnect(), 5000);
}

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior(to, from, savedPosition) {
      // < Hash
      if (to.hash) {
        return new Promise((resolve) => {
          waitForElement(to.hash, () => {
            resolve({
              el: to.hash,
              left: 0,
              top: 0,
              // behavior: 'smooth',
            });
          });
        });
      }
      // >

      // if (to.hash) {
      //   return {
      //     el: to.hash,
      //     left: 0,
      //     top: 64,
      //     behavior: 'smooth',
      //   };
      // }

      if (savedPosition) {
        return savedPosition;
      }

      return { left: 0, top: 0 };
    },
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  return Router;
});
